<!--
 * @Description: 注册中心首页
 * @Author: Songsong_yu
 * @Date: 2019-07-04 10:11:22
 * @LastEditTime: 2020-04-30 14:39:34
 * @LastEditors: Songsong_yu
 -->
<template>
    <div id="registerIndex">
        <!--测试找回密码按钮 !s-->
        <!--<el-button type="primary" style="background: red; position: absolute;float: right; right: 100px; top: 23px;" @click="$router.push('/resetPassword')">测试找回密码</el-button>-->
        <!--测试找回密码按钮 !e-->
        <lang-select class="set-language"></lang-select>
        <div class="register-box">
            <div class="register-step-box">
                <el-steps :active="stepActiveNum" finish-status="success" align-center>
                    <el-step :title="$t('Form.SignIn')" description=""></el-step>
                    <el-step :title="$t('Form.Verification')" description=""></el-step>
                    <el-step :title="$t('Form.Active')" description=""></el-step>
                </el-steps>
            </div>
            <div class="register-info-box" v-if="isActiveUserCard">
                <active-user-card
                    :title="$t('Form.ActiveAccount')"
                    :resetKey="resetKey"
                    :typeVal="typeVal"
                    @close="closeClick"
                    @activeSuccess="handleActiveSuccess"
                ></active-user-card>
            </div>
            <div class="register-info-box" v-else>
                <transition mode="out-in" :enter-active-class="enterActiveClass" :leave-active-class="leaveActiveClass">
                    <user-info-card
                        :title="$t('Form.Title')"
                        :userInfo="userInfo"
                        id="card-1"
                        class="animated fast"
                        v-if="index === 1"
                        key="card-1"
                        @nextStep="nextStepClick"
                    ></user-info-card>
                    <company-info-card
                        ref="companyInfoCard"
                        :title="$t('Form.Title')"
                        id="card-2"
                        class="animated fast"
                        v-if="index === 2"
                        key="card-2"
                        @previousStep="previousClick"
                        @submit="submitClick"
                    ></company-info-card>
                    <submit-success-card
                        :title="$t('Form.SubmitSuccess')"
                        id="card-3"
                        class="animated fast"
                        v-if="index === 3"
                        key="card-3"
                        @close="closeClick"
                    ></submit-success-card>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapActions } from 'vuex';
import UserInfoCard from './components/userInfoCard'
import CompanyInfoCard from './components/companyInfoCard'
import SubmitSuccessCard from './components/submitSuccessCard'
import ActiveUserCard from './components/activeUserCard'
import { apiRegister } from '@/api/register'
import { FormMixin } from '@/mixins'

export default {
    name: 'RegisterIndex',
    mixins: [FormMixin],
    components: { UserInfoCard, CompanyInfoCard, SubmitSuccessCard, ActiveUserCard },
    data() {
        return {
            stepActiveNum: 0,
            index: 1, //显示的组件索引--初始定位1即第一张内容卡片
            enterActiveClass: 'zoomInRight',
            leaveActiveClass: 'zoomOutLeft',
            userInfo: {},
            companyInfo: {},

            isActiveUserCard: false, //激活账号card
            resetKey: '',
            typeVal: '', //0:主账号激活， 1:子账号激活， 2:找回密码, 3: 协作账号激活, 4: 换绑账号激活
        }
    },
    created() {
        this.checkRouter()
    },
    methods: {
        checkRouter() {
            this.resetKey = this.$route.query.key
            this.typeVal = this.$route.query.type
            const serverPlatform = process.env.VUE_APP_SERVER_PLATFORM
            const language = this.$route.query.language
            if (this.typeVal === '2') {
                if (this.resetKey !== undefined && this.resetKey !== '') {
                    this.isActiveUserCard = false
                } else {
                    this.isActiveUserCard = false
                }
            } else if (this.typeVal === '0' || this.typeVal === '1' || this.typeVal === '3' || this.typeVal === '4') {
                this.isActiveUserCard = true
                this.stepActiveNum = 2
            } else {
                this.isActiveUserCard = false
            }
            if ((language && language !== 'undefined' && language !== 'null' && language === 'en') || serverPlatform === 'AWS') {
                this.$i18n.locale = 'en'
                this.$store.dispatch('app/setLanguage', 'en')
            } else {
                this.$i18n.locale = 'zh'
                this.$store.dispatch('app/setLanguage', 'zh')
            }
            /*if (language !== undefined && language === 'en'){
          this.setLanguage('en');
        }else {
          this.setLanguage('zh');
        }*/
        },
        changeIndexPlus() {
            this.enterActiveClass = 'zoomInRight'
            this.leaveActiveClass = 'zoomOutLeft'
            // this.index = (this.index%2)+1;
            if (this.index === 2) {
                this.stepActiveNum = 1
            }
            this.index = this.index + 1
        },
        changeIndexMinus() {
            this.enterActiveClass = 'zoomInLeft'
            this.leaveActiveClass = 'zoomOutRight'
            if (this.index === 1) {
                return
            }
            this.index = this.index - 1
        },
        nextStepClick(userInfo) {
            if (userInfo) {
                this.userInfo = userInfo
                this.changeIndexPlus()
            }
        },
        previousClick() {
            this.changeIndexMinus()
        },
        // 注册提交
        submitClick(companyInfo) {
            if (companyInfo) {
                this.companyInfo = companyInfo
                let data = Object.assign({}, this.userInfo, this.companyInfo, { utype: this.mgType, registerUrl: this.registerUrl })
                apiRegister(data)
                    .then(res => {
                        this.$refs.companyInfoCard.btnLoading = false
                        this.$message.success(this.$t('Message.MsgCode14'))
                        this.changeIndexPlus()
                    }).catch(err => {
                        console.log(err)
                        this.$refs.companyInfoCard.btnLoading = false
                        this.$message.error(this.$t('Message.MsgCode' + err.code))
                    })
            }
        },
        closeClick() {
            this.userInfo = {}
            this.companyInfo = {}
            this.enterActiveClass = 'zoomInLeft'
            this.leaveActiveClass = 'zoomOutRight'
            this.index = 1
            this.stepActiveNum = 0
            this.isActiveUserCard = false
            this.$router.push('/register')
        },

        handleActiveSuccess() {
            this.stepActiveNum = 3
        },

        // ...mapActions(['setLanguage'])
    },
}
</script>

<style lang="scss">
$color-theme: #4da1ff;

#registerIndex {
    .register-box {
        .register-step-box {
            width: 1000px;
            height: 50px;
            position: absolute;
            top: 15%;
            left: 50%;
            margin: -25px 0 0 -500px;

            .el-step {
                .el-step__head {
                    .el-step__line {
                        top: 27.5px;
                        height: 5px;
                        background: #fff;
                    }
                    .el-step__icon.is-text {
                        width: 60px;
                        height: 60px;
                        font-size: 20px;
                        border-color: #fff;
                    }
                }
                .el-step__head.is-success {
                    color: $color-theme;
                    border-color: $color-theme;
                    .el-step__line {
                        background: $color-theme;
                    }
                    .el-step__icon.is-text {
                        background: $color-theme;
                        border-color: $color-theme;
                    }
                    .el-step__icon-inner.is-status.el-icon-check {
                        color: #13ec0d;
                        border-color: #13ec0d;
                        font-weight: bold;
                    }
                }
                .el-step__head.is-process {
                    color: $color-theme;
                    border-color: $color-theme;

                    .el-step__line {
                        background: linear-gradient(to right, rgba(77, 161, 255, 1), white);
                    }

                    .el-step__icon.is-text {
                        background: $color-theme;
                        border-color: $color-theme;
                        .el-step__icon-inner {
                            color: #fff;
                        }
                    }
                }
                .el-step__main {
                    .el-step__title {
                        font-size: 20px;
                    }
                    .is-process {
                        color: #fff;
                    }
                    .el-step__title.is-success {
                        color: #fff;
                    }
                }
            }
        }

        .register-info-box {
            width: 500px;
            // height: 600px;
            position: absolute;
            top: 30%;
            left: 50%;
            margin: 0 0 50px -250px;

            #card-1 {
            }
            #card-2 {
            }
            #card-3 {
                width: 600px;
                margin: 0 0 0 -50px;
            }
            .register-info-user {
            }
            .register-info-company {
            }
        }
    }
}
</style>
